export const fileKeyEndpoints = {
  // Lists the current user's file keys ({ fileId, fileKey }) across every SIX
  // they belong to. cqrs SDB-726 (GetUserFileKeysController, sixes module).
  getUserFileKeys: '/private/v1/sixes/file-keys',

  // Hands the tar CID of the regenerated file keys to HAP, which fetches the
  // bundle, untars it, and puts every key blob into its own Helia. Pure byte
  // transfer — nothing reaches Fabric or the read store. cqrs SDB-733
  // (UploadCompressedUpdatedFileKeysCidController), routed to the HAP processor.
  uploadRotatedFileKeys: '/private/v1/auth/credentials/rotate/file-keys',

  // Commits the rotation in one command: OPAQUE registration record, the full
  // fileId→CID mapping, and the new ML-KEM keys. Goes through the credential
  // rotation saga → Fabric. cqrs SDB-733/734 (FinalizeCredentialRotationController).
  finalizeKeyRotation: '/private/v1/auth/credentials/rotate/finalize',
} as const;

export type FileKeyEndpointKey = keyof typeof fileKeyEndpoints;
